import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { transferArrayItem, moveItemInArray } from "@angular/cdk/drag-drop";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { ViewChild, TemplateRef } from "@angular/core";
import { MatDialog } from "@angular/material";
import { GUID } from "./../../guid";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";

// import { MultiSelectModule } from 'primeng/multiselect';
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { AppConfig } from "src/app/config";

interface City {
  name: string;
  code: string;
}
@Component({
  selector: "app-newreport",
  templateUrl: "./newreport.component.html",
  styleUrls: ["./newreport.component.scss"]
  // imports: [MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule],
})
export class NewreportComponent implements OnInit {
  @ViewChild("columnDialog", { static: false }) columnDialog!: TemplateRef<any>;
  @ViewChild("groupRowsDialog", { static: false })
  groupRowsDialog!: TemplateRef<any>;
  @ViewChild("saveDialog", { static: false }) saveDialog!: TemplateRef<any>;

  isChecked = true;
  isDataLoaded = false;
  guid: GUID;
  isLoading = false;
  isError = false;
  errorMessage = "";
  report: any;
  reportTypes = [];
  gridData = [];
  reporttypecolumn = [];
  reporttypesection = [];
  columnsToDo = [];
  columnsDone = [];
  mode = "";
  groupsToDo = [];
  groupRowsDone = [];
  groupColumnsDone = [];
  reportId = "";
  operatorList = [];
  typeList = [];
  fieldList = [];
  filterForm: FormGroup;
  picklistValueList = [];

  metaobjectId = "";
  metaobjectName = "";
  fields: any[] = [];
  reportType: Array<any>;
  folders: Array<any>;

  reportTypeId = "";
  sectionsWithFields: {
    name: string;
    fields: { name: string; fieldid: string }[];
  }[] = [];
  data: any = {};
  dialogRef: any;
  selectedField: any;
  reportcolumnId = "";
  reportGroupingcolumnId = "";
  reportGroupingRowId = "";
  // ReportId = "";
  reportJsontextId = "";
  reportName = "";
  selectedSummarize: string[] = [];
  // Define your toppingList here
  summarizeList: string[] = ["Sum", "Average", "Maximum", "Minimum", "Median"];
  sorttypeList: string[] = ["Column", "Aggregate"];
  groupdateList: string[] = [
    "None",
    "Day",
    "Week",
    "Month",
    "Quarter",
    "Year",
    "Fiscal Quarter",
    "Fiscal Year",
    "Month In Year",
    "Day In Month",
    "Fiscal Period",
    "Fiscal Week"
  ];

  checkboxValueList = [
    { value: true, label: "True" },
    { value: false, label: "False" }
  ];

  // this.formGroup = this.formBuilder.group({
  //   rowcounts: [false] // Initial value of the slide toggle
  // });
  // filterForm: FormGroup;
  columnForm = this.fb.group({
    sort: [""], // Initialize with empty string
    showuniquecount: [false], // Initialize with false
    sortingcolumn: [false],
    selectedSummarize: [[]] // Initialize with empty array
  });
  formGroup = this.fb.group({
    rowcounts: [true],
    detailrows: [true],
    subtotals: [true],
    grandtotals: [true],
    stackedsummaries: [true],
    sortcolumn: "",
    rowlimit: [1],
    targeturl: [""],
    scope: ["My"],
    reportformat: ["Joined"],
    sortorder: ["Ascending"],
    sortcolumnname: [""],
    sortobjectname: [""]
  });
  saveForm = this.fb.group({
    label: "",
    name: "",
    description: "",
    folder: "",
    folderid: "",
    foldername: ""
  });
  detailForm = this.fb.group({
    label: "",
    name: "",
    pluralname: "",
    node: "",
    objecttype: "",
    category: "",
    description: "",
    standard: false,
    parentobjectid: "",
    parentobjectname: "",
    parentobject: "",
    embeddedobject: false,
    virtualobject: false,
    active: true,
    rowcounts: false,
    allowactivities: false,
    trackfieldhistory: false,
    allowsearch: false,
    enablelicensing: false,
    allowworkflow: false,
    notesandattachments: false,
    iconname: ""
  });
  detailForm11 = this.fb.group({
    label: "",
    pluralname: "",
    node: "",
    objecttype: "",
    category: "",
    description: "",
    standard: false,
    parentobjectid: "",
    parentobjectname: "",
    parentobject: "",
    embeddedobject: false,
    virtualobject: false,
    active: true,
    allowreports: false,
    allowactivities: false,
    trackfieldhistory: false,
    allowsearch: false,
    enablelicensing: false,
    allowworkflow: false,
    notesandattachments: false,
    iconname: ""
  });

  drop(event: CdkDragDrop<string[]>) {
    this.selectedField = event.item.data;

    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      //console.log("event.previousContainer", event.previousContainer.id);
      //console.log("event.container", event.container.id);
      //console.log("event.previousIndex", event.previousIndex);

      //prevent dragging the name field
      var fld = event.previousContainer.data[event.previousIndex];
      // if (fld["fieldname"] == "name") return;

      //var fld = JSON.parse(event.previousContainer.data[event.previousIndex]);
      //console.log(fld.fieldname);
      //if(event.previousContainer.data[event.previousIndex].fieldname.)
      /*if(event.previousContainer.id = 'cdk-drop-list-1') //DoneList
      {
        if(this.fieldsDone.length == 1){
          this.showWarning("Selected fields cannot be empty");
          return;           
        }
      }*/

      if (this.columnsDone.length < 25) {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }

      // if (this.groupRowsDone.length < 25) {
      //   transferArrayItem(
      //     event.previousContainer.data,
      //     event.container.data,
      //     event.previousIndex,
      //     event.currentIndex
      //   );
      // }

      // if (this.groupColumnsDone.length < 25) {
      //   transferArrayItem(
      //     event.previousContainer.data,
      //     event.container.data,
      //     event.previousIndex,
      //     event.currentIndex
      //   );
      // }
    }
  }

  // fieldSelected(
  //   event: { id: any; fieldtype: any; options: string; metaobjectname: string },
  //   index: number
  // ) {
  //   console.log("fieldSelected");
  //   console.log("index", index);
  //   console.log("event", event);

  //   var i = 0;
  //   var arrayControl = this.filterForm.get("filteritems") as FormArray;
  //   for (let c of arrayControl.controls) {
  //     if (i == index) {
  //       console.log("matching", c);
  //       c.get("fieldid").setValue(event.id);
  //       c.get("fieldtype").setValue(event.fieldtype);
  //       c.get("options").setValue(event.options);
  //       c.get("metaobjectname").setValue(event.metaobjectname);

  //       if (c.get("fieldoperator").value == "") {
  //         c.get("fieldoperator").setValue("equals"); //default operator set
  //       }
  //       if (event.options != "") {
  //         var arr = JSON.parse(event.options);
  //         this.picklistValueList[index] = arr;
  //         c.get("fieldoperator").setValue("equals"); //default operator set
  //       }
  //       c.get("fieldvalue").setValue("");
  //       break;
  //     }
  //     i++;
  //   }
  // }

  // createfilterItem(
  //   id: any,
  //   name: any,
  //   ftype: any,
  //   opt: any,
  //   opr: any,
  //   typ: any,
  //   vl: any,
  //   flogic: string,
  //   objname: string
  // ): FormGroup {
  //   return this.fb.group({
  //     //fieldlist: fldlist,
  //     //operatorlist: oplist,
  //     fieldid: id,
  //     fieldname: name,
  //     fieldtype: ftype,
  //     options: opt,
  //     fieldoperator: opr,
  //     type: typ,
  //     fieldvalue: vl,
  //     filterlogic: flogic,
  //     metaobjectname: objname
  //     // filtertype: "",
  //     // errormessage: "",
  //     // lookuptext: "",
  //     // active: "",
  //   });
  // }
  // addFilterItem(
  //   id: string,
  //   name: string,
  //   ftype: string,
  //   opt: string | any[],
  //   opr: string,
  //   typ: any,
  //   vl: string,
  //   flogic = "AND",
  //   objname: string
  // ): void {
  //   this.filteritems = this.filterForm.get("filteritems") as FormArray;
  //   this.filteritems.push(
  //     this.createfilterItem(name, id, ftype, opt, opr, typ, vl, flogic, objname)
  //   );
  //   this.picklistValueList.push([]);
  // }

  // fieldSelected(event: any, index: number) {
  //   const arrayControl = this.filterForm.get("filteritems") as FormArray;
  //   const c = arrayControl.at(index);

  //   // 🔹 UI select correct ah show aaganum na
  //   c.get("fieldname").setValue(event.value); // dropdown expects value

  //   // 🔹 actual db field name store separately
  //   c.get("fieldid").setValue(event.id); // real field name

  //   c.get("fieldtype").setValue(event.fieldtype);
  //   c.get("metaobjectname").setValue(event.metaobjectname);

  //   if (!c.get("fieldoperator").value) {
  //     c.get("fieldoperator").setValue("equals");
  //   }

  //   c.get("fieldvalue").setValue("");
  // }

  fieldSelected(event: any, index: number) {
    const arrayControl = this.filterForm.get("filteritems") as FormArray;
    const c = arrayControl.at(index);

    c.get("fieldname").setValue(event.value);
    c.get("fieldid").setValue(event.id);
    c.get("fieldtype").setValue(event.fieldtype);
    c.get("metaobjectname").setValue(event.metaobjectname);

    if (!c.get("fieldoperator").value) {
      c.get("fieldoperator").setValue("equals");
    }

    // 🔥 picklist dropdown values
    if (event.fieldtype === "picklist") {
      const selectedField = this.fields.find((f) => f.fieldname === event.id);

      if (selectedField && selectedField.options) {
        const arr = JSON.parse(selectedField.options);

        this.picklistValueList[index] = arr.map((v) => ({
          value: v.value,
          label: v.label
        }));
      }
    }

    c.get("fieldvalue").setValue("");
  }

  addFilter() {
    const filterArray = this.filterForm.get("filteritems") as FormArray;

    if (filterArray.length < 10) {
      filterArray.push(this.createFilterItem());
      this.picklistValueList.push([]);
    }
  }

  removeFilter(index: number) {
    const filterArray = this.filterForm.get("filteritems") as FormArray;

    if (filterArray.length > 1) {
      filterArray.removeAt(index);
      this.picklistValueList.splice(index, 1);
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService,
    private appConfig: AppConfig,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;

      this.reportId = this.route.snapshot.params.id;
      this.reportName = this.route.snapshot.params.name;
    });
    console.log(this.reportId);
    if (this.mode.toLowerCase() == "new") {
      this.detailForm.controls.parentobject.enable();
      this.isDataLoaded = true;
    } else if (this.mode.toLowerCase() == "edit") {
      this.detailForm.controls.parentobject.disable();
    }

    if (this.mode.toLowerCase() == "edit") {
      this.getReportById().then((res) => {
        this.reportTypeId = this.report.reporttypeid;
        this.metaobjectId = this.report.metaobjectid;
        this.metaobjectName = this.report.metaobjectname;

        console.log("response11111", this.report.reportlabel);
        const reportGroupRow = this.report.reportgroupingrow;
        const reportGroupColumn = this.report.reportgroupingcolumn;
        const reportColumn = this.report.reportcolumn;

        console.log(this.groupsToDo);
        // for (const groupField of this.groupsToDo) {
        //   // Find the matching field in the reportColumn array
        //   const matchingField = this.report.reportcolumn.find((item: any) => item.fieldid === groupField.fieldid);

        // }

        this.getReportTypeSectionById().then(() => {
          this.getReportTypeColumnById().then(() => {
            this.bindReportFilters();

            const flattenedFields = [];
            const groupFields = [];
            for (const section of this.reporttypesection) {
              const sectionName = section.sectionname;
              // console.log(this.reporttypecolumn);
              const fields = this.reporttypecolumn
                .filter((column) => column.reporttypesectionid === section.id)
                .map((column) => ({
                  name: column.displaynameoverride,
                  fieldid: column.fieldid,
                  fieldname: column.fieldname,
                  reporttypeid: column.reporttypeid,
                  labelname: column.displaynameoverride,
                  datatype: column.datatype,
                  section: sectionName // Include section name with each field
                }));
              flattenedFields.push(...fields);
              groupFields.push(...fields);
            }
            this.columnsToDo = flattenedFields;
            this.groupsToDo = groupFields;
            // console.log(flattenedFields);

            const mappedGroupRowFields = reportGroupRow.map(
              (reportGroupRowfield) => {
                const fields = this.groupsToDo.map((field) => {
                  if (reportGroupRowfield.fieldid == field.fieldid) {
                    // this.groupRowsDone.push(field);
                    this.groupRowsDone.push({
                      ...field,
                      sort: reportGroupRowfield.sortorder,
                      sorttype: reportGroupRowfield.sorttype,
                      groupdate: reportGroupRowfield.dategranularity
                    });
                  }
                });
              }
            );

            this.groupsToDo = this.groupsToDo.filter((field) => {
              // Check if the fieldid exists in groupRowsDone
              const existsInGroupRowsDone = this.groupRowsDone.some(
                (row) => row.fieldid === field.fieldid
              );
              return !existsInGroupRowsDone;
            });

            // const mappedGroupRowFields = reportGroupRow.map((reportGroupRowField) => {
            //   const fieldIndex = this.groupsToDo.findIndex((field) => field.fieldid === reportGroupRowField.fieldid);
            //   if (fieldIndex !== -1) {
            //     // Field found in groupsToDo, remove it and push to groupRowsDone
            //     const fieldToRemove = this.groupsToDo.splice(fieldIndex, 1)[0];
            //     this.groupRowsDone.push(fieldToRemove);
            //   }
            // });

            const mappedGroupColumnFields = reportGroupColumn.map(
              (reportGroupColumnfield) => {
                const fields = this.groupsToDo.map((field) => {
                  if (reportGroupColumnfield.fieldid == field.fieldid) {
                    // this.groupColumnsDone.push(field);
                    this.groupColumnsDone.push({
                      ...field,
                      sort: reportGroupColumnfield.sortorder,
                      sorttype: reportGroupColumnfield.sorttype,
                      groupdate: reportGroupColumnfield.dategranularity
                    });
                  }
                });
              }
            );
            this.groupsToDo = this.groupsToDo.filter((field) => {
              // Check if the fieldid exists in groupRowsDone
              const existsInGroupColumnsDone = this.groupColumnsDone.some(
                (row) => row.fieldid === field.fieldid
              );
              return !existsInGroupColumnsDone;
            });

            const mappedColumnFields = reportColumn.map((reportColumnfield) => {
              const fields = this.columnsToDo.map((field) => {
                if (reportColumnfield.fieldid == field.fieldid) {
                  // this.columnsDone.push(field);

                  this.columnsDone.push({
                    ...field,
                    sort: reportColumnfield.sortorder,
                    // sorttype:reportColumnfield.sorttype,
                    groupdate: reportColumnfield.dategranularity,
                    selectedSummarize: reportColumnfield.aggregatetype,
                    sortingcolumn: reportColumnfield.sortingcolumn,
                    showuniquecount: reportColumnfield.showuniquecount
                  });
                  console.log(this.columnsDone);
                }
              });
            });
            this.columnsToDo = this.columnsToDo.filter((field) => {
              // Check if the fieldid exists in groupRowsDone
              const existsInColumnsDone = this.columnsDone.some(
                (row) => row.fieldid === field.fieldid
              );
              return !existsInColumnsDone;
            });
          });
        });
        // console.log("parentobjects", this.parentObjects);
        this.saveForm.controls["label"].setValue(this.report.reportlabel);
        this.saveForm.controls["name"].setValue(this.report.reportname);
        this.saveForm.controls["description"].setValue(this.report.description);
        this.saveForm.controls["folder"].setValue(this.report.folderid);
        this.saveForm.controls["folderid"].setValue(this.report.folderid);

        this.detailForm.controls["parentobject"].setValue(
          this.report.reporttypeid
        );
        this.detailForm.controls["parentobjectid"].setValue(
          this.report.reporttypeid
        );
        this.formGroup.controls["detailrows"].setValue(
          this.report.showdetailrows
        );
        this.formGroup.controls["grandtotals"].setValue(
          this.report.showgrandtotals
        );
        this.formGroup.controls["subtotals"].setValue(
          this.report.showsubtotals
        );
        this.formGroup.controls["sortcolumn"].setValue(this.report.sortcolumn);
        this.formGroup.controls["sortorder"].setValue(this.report.sortorder);
        this.formGroup.controls["rowlimit"].setValue(this.report.rowlimit);
        this.formGroup.controls["targeturl"].setValue(this.report.targeturl);

        this.formGroup.controls["scope"].setValue(this.report.scope);
        this.formGroup.controls["sortcolumnname"].setValue(
          this.report.sortcolumnname
        );
        this.formGroup.controls["sortobjectname"].setValue(
          this.report.sortobjectname
        );

        this.formGroup.controls["reportformat"].setValue(
          this.report.reportformat
        );
        this.formGroup.controls["rowcounts"].setValue(
          this.report.showrowcounts
        );
        this.formGroup.controls["stackedsummaries"].setValue(
          this.report.showstackedsummaries
        );
        //this.detailForm.controls.parentobject.patchValue('');
      });
    }
    this.getReportType();
    this.getFolder();
    this.guid = new GUID();

    this.filterForm = this.fb.group({
      filterlogic: [""],
      locked: [false],
      filteritems: this.fb.array([this.createFilterItem()])
    });

    for (let i = 0; i < this.appConfig.operatorTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.operatorTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.operatorList.push({
        value: this.appConfig.operatorTypes[i],
        label: strLabel
      });
    }

    for (let i = 0; i < this.appConfig.lookupfiltertypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.lookupfiltertypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.typeList.push({
        value: this.appConfig.lookupfiltertypes[i],
        label: strLabel
      });
    }
  }

  bindReportFilters() {
    if (!this.report) return;

    const filterArray = this.filterForm.get("filteritems") as FormArray;
    filterArray.clear();
    this.picklistValueList = [];

    if (this.report.reportfilter && this.report.reportfilter.length > 0) {
      // ✅ Correct source for filterlogic
      this.filterForm.controls["filterlogic"].setValue(
        this.report.reportfilter[0].filterlogic || ""
      );

      // ✅ Locked
      this.filterForm.controls["locked"].setValue(
        this.report.reportfilter[0].locked || false
      );

      this.report.reportfilter.forEach((f: any) => {
        const matchedField = this.fieldList.find(
          (fld: any) => fld.id === f.fieldname
        );

        filterArray.push(
          this.fb.group({
            fieldid: [f.fieldname],
            fieldname: [matchedField ? matchedField.value : ""],
            fieldtype: [matchedField ? matchedField.fieldtype : ""],
            fieldoperator: [f.operator],
            fieldvalue: [f.value],
            metaobjectname: [matchedField ? matchedField.metaobjectname : ""],
            options: [""]
          })
        );

        this.picklistValueList.push([]);
      });
    } else {
      filterArray.push(this.createFilterItem());
    }
  }
  createFilterItem(): FormGroup {
    return this.fb.group({
      fieldid: [""], // ✅ actual field id
      fieldname: [""], // optional if needed
      fieldtype: [""],
      fieldoperator: [""],
      fieldvalue: [""],
      metaobjectname: [""],
      options: [""]
    });
  }

  get filterItems(): FormArray {
    return this.filterForm.get("filteritems") as FormArray;
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  folderChange(event: { value: string; label: string }) {
    if (event.value.trim() !== "") {
      // this.reportTypeId = event.value;
      this.saveForm.controls["folderid"].setValue(event.value);
      this.saveForm.controls["foldername"].setValue(event.label);
    } else {
      this.saveForm.controls["folderid"].setValue("");
      this.saveForm.controls["foldername"].setValue("");
    }
  }

  // parentObjectChange(event: { value: string; label: any }) {
  //   console.log("parentObjectChange", event);
  //   if (event.value.trim() != "") {
  //     this.reportTypeId = event.value;

  //     this.detailForm.controls["parentobjectid"].setValue(event.value);
  //     this.detailForm.controls["parentobjectname"].setValue(event.label);

  //     this.getReportTypeSectionById().then(async () => {
  //       await this.getReportTypeColumnById();
  //       const gridData = [];
  //       console.log("ReportTypeSection:", this.reporttypesection);
  //       console.log("ReportTypeColumn:", this.reporttypecolumn);
  //       for (const section of this.reporttypesection) {
  //         const sectionId = section.id;
  //         const sectionName = section.sectionname;
  //         const matchingColumns = this.reporttypecolumn.filter(
  //           (column) => column.reporttypesectionid === sectionId
  //         );
  //         const fieldnames = matchingColumns.map((column) => ({
  //           name: column.displaynameoverride,
  //           checked: column.checkedbydefault,
  //           fieldid: column.fieldid,
  //         }));
  //         gridData.push({ sectionId, sectionName, fieldnames });
  //       }
  //       console.log("Grid Data:", gridData);
  //       this.gridData = gridData;
  //     });
  //   } else {
  //     this.detailForm.controls["parentobjectid"].setValue("");
  //     this.detailForm.controls["parentobjectname"].setValue("");
  //   }
  // }

  // parentObjectChange(event: { value: string; label: string }) {
  //   if (event.value.trim() !== "") {
  //     this.reportTypeId = event.value;
  //     this.detailForm.controls["parentobjectid"].setValue(event.value);
  //     this.detailForm.controls["parentobjectname"].setValue(event.label);

  //     this.getReportTypeSectionById().then(() => {
  //       this.getReportTypeColumnById().then(() => {
  //         const sectionsWithFields = [];
  //         for (const section of this.reporttypesection) {
  //           const sectionName = section.sectionname;
  //           const fields = this.reporttypecolumn
  //             .filter((column) => column.reporttypesectionid === section.id)
  //             .map((column) => ({
  //               name: column.displaynameoverride,
  //               fieldid: column.fieldid,
  //             }));
  //           sectionsWithFields.push({ name: sectionName, fields: fields });
  //         }
  //         this.sectionsWithFields = sectionsWithFields;
  //         console.log(sectionsWithFields)
  //       });
  //     });
  //   } else {
  //     this.detailForm.controls["parentobjectid"].setValue("");
  //     this.detailForm.controls["parentobjectname"].setValue("");
  //   }
  // }
  // fieldsList = [];
  // parentObjectChange(event: { value: string; label: string }) {
  //   if (event.value.trim() !== "") {
  //     this.reportTypeId = event.value;
  //     this.detailForm.controls["parentobjectid"].setValue(event.value);
  //     this.detailForm.controls["parentobjectname"].setValue(event.label);

  //     this.getReportTypeSectionById().then(() => {
  //       this.getReportTypeColumnById().then(() => {
  //         const flattenedFields = [];
  //         const groupFields = [];
  //         for (const section of this.reporttypesection) {
  //           const sectionName = section.sectionname;
  //           // console.log(this.reporttypecolumn);
  //           const fields = this.reporttypecolumn
  //             .filter((column) => column.reporttypesectionid === section.id)
  //             .map((column) => ({
  //               name: column.displaynameoverride,
  //               fieldid: column.fieldid,
  //               fieldname: column.fieldname,
  //               reporttypeid: column.reporttypeid,
  //               labelname: column.displaynameoverride,
  //               datatype: column.datatype,
  //               section: sectionName // Include section name with each field
  //             }));
  //           flattenedFields.push(...fields);
  //           groupFields.push(...fields);
  //         }
  //         this.columnsToDo = flattenedFields;
  //         this.groupsToDo = groupFields;
  //         console.log(groupFields);
  //       });
  //     });
  //   } else {
  //     this.detailForm.controls["parentobjectid"].setValue("");
  //     this.detailForm.controls["parentobjectname"].setValue("");
  //   }
  // }

  parentObjectChange(event: { value: string; label: string }) {
    if (event.value.trim() !== "") {
      this.reportTypeId = event.value;

      this.detailForm.controls["parentobjectid"].setValue(event.value);
      this.detailForm.controls["parentobjectname"].setValue(event.label);

      // 🔥 REPORT TYPE OBJECT FIND
      // const selectedReport = this.reportType.find(
      //   (r) => r.value === event.value
      // );

      // if (selectedReport) {
      //   this.metaobjectId = selectedReport.value;
      //   this.metaobjectName = selectedReport.label;
      // }
      const selectedReport = this.reportType.find(
        (r) => r.value === event.value
      );

      if (selectedReport) {
        this.metaobjectId = selectedReport.metaobjectid;
        this.metaobjectName = selectedReport.metaobjectname;
      }

      console.log("metaobjectId", this.metaobjectId);
      console.log("metaobjectName", this.metaobjectName);

      // 🔥 CALL META FIELD API
      this.getMetaFieldsForSelection();

      this.getReportTypeSectionById().then(() => {
        this.getReportTypeColumnById().then(() => {
          const flattenedFields = [];
          const groupFields = [];

          for (const section of this.reporttypesection) {
            const sectionName = section.sectionname;

            const fields = this.reporttypecolumn
              .filter((column) => column.reporttypesectionid === section.id)
              .map((column) => ({
                name: column.displaynameoverride,
                fieldid: column.fieldid,
                fieldname: column.fieldname,
                reporttypeid: column.reporttypeid,
                labelname: column.displaynameoverride,
                datatype: column.datatype,
                section: sectionName
              }));

            flattenedFields.push(...fields);
            groupFields.push(...fields);
          }

          this.columnsToDo = flattenedFields;
          this.groupsToDo = groupFields;
        });
      });
    } else {
      this.detailForm.controls["parentobjectid"].setValue("");
      this.detailForm.controls["parentobjectname"].setValue("");
    }
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            // this.metafields = res.data.metafields;
            this.fields = res.data.metafields;

            this.isLoading = false;
            resolve(this.fields);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
  selectedOptions: { name: string; fieldid: string }[] = [];

  // childObjectChange(selectedValue: string) {
  //   const selectedField = this.getSelectedFieldById(selectedValue);
  //   if (selectedField) {
  //     this.selectedOptions.push(selectedField);
  //   }
  //   console.log(this.selectedOptions)
  // }
  // childObjectChange(event: Event) {
  //   const selectedValue = (event.target as HTMLSelectElement).value;
  //   if (selectedValue.trim() !== '') {
  //     const selectedField = this.getSelectedFieldById(selectedValue);
  //     if (selectedField) {
  //       this.selectedOptions.push(selectedField);
  //     }
  //   }
  //   console.log(this.selectedOptions);
  // }
  childObjectChange(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    if (selectedValue.trim() !== "") {
      const selectedField = this.getSelectedFieldById(selectedValue);
      if (selectedField) {
        this.selectedOptions.push(selectedField);

        console.log(this.selectedOptions);
        // Remove selected option from the dropdown options
        this.removeSelectedOption(selectedValue);
      }
    }
  }

  removeSelectedOption(selectedValue: string) {
    // Loop through sectionsWithFields to remove the selected option
    for (const section of this.sectionsWithFields) {
      section.fields = section.fields.filter(
        (field) => field.fieldid !== selectedValue
      );
    }
  }

  isSelected(fieldId: string): boolean {
    return this.selectedOptions.some((option) => option.fieldid === fieldId);
  }

  private getSelectedFieldById(
    fieldId: string
  ): { name: string; fieldid: string } | undefined {
    for (const section of this.sectionsWithFields) {
      for (const field of section.fields) {
        if (field.fieldid === fieldId) {
          return { ...field };
        }
      }
    }
    return undefined;
  }
  isNumberField(field: any): boolean {
    console.log(field);
    // Check if the datatype of the field is a number
    // return field.datatype === "number";
    return field.datatype === "int" || field.datatype === "double";
  }
  isDateField(field: any): boolean {
    // console.log(field.datatype);
    // Check if the datatype of the field is a date
    return field.datatype === "date";
  }

  columnattributes(field: any): void {
    console.log("field", field);
    if (!field) {
      return; // Do not open dialog if no field is selected
    }

    // Initialize data object with field name and checked value
    this.data = {
      name: field.name,
      sort: field.sort,
      datatype: field.datatype,
      showuniquecount: field.showuniquecount ? true : false,
      fieldid: field.fieldid,
      selectedSummarize: field.selectedSummarize,
      sortingcolumn: field.sortingcolumn
    };

    // const formData = this.columnForm.value;

    //
    // const formData = {
    //   name: field.name,
    //   datatype: field.datatype,
    //   showuniquecount: field.showuniquecount ? true : false,
    //   fieldid: field.fieldid,
    //   sort: '', // Add sort property
    //   selectedSummarize: [] // Add selectedSummarize property
    // };

    // You can now use formData to access form values
    // console.log("Form data:", formData);

    if (this.mode.toLocaleLowerCase() == "edit") {
      const matchingField = this.report.reportcolumn.find(
        (item: any) => item.fieldid === field.fieldid
      );
      console.log(matchingField);
      if (!matchingField) {
        return; // If no matching field is found in the response data, do nothing
      }

      const aggregate = [];
      aggregate.push(matchingField.aggregatetype);
      // // Initialize data object with matching field data
      this.data = {
        name: matchingField.name || matchingField.fieldname,
        sort: matchingField.sortorder,
        datatype: matchingField.datatype,
        showuniquecount: matchingField.showuniquecount ? true : false,
        fieldid: matchingField.fieldid,
        selectedSummarize: matchingField.selectedSummarize || aggregate,
        sortingcolumn: matchingField.sortingcolumn ? true : false

        // summarize: this.selectedSummarize,
      };
    }

    // Open the dialog with the initialized data
    this.dialogRef = this.dialog.open(this.columnDialog, {
      data: this.data,
      height: "300px",
      width: "400px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
        // Update the name of the selected field in the grid data
        // this.selectedFieldNameMap[field.sectionName] = field;
      }
    });
  }

  grouprowattributes(field: any): void {
    console.log("field", field);
    if (!field) {
      return; // Do not open dialog if no field is selected
    }

    // Initialize data object with field name and checked value
    this.data = {
      name: field.name,
      sort: field.sort,
      datatype: field.datatype,
      showuniquecount: field.showuniquecount ? true : false,
      fieldid: field.fieldid,
      sorttype: field.sorttype,
      groupdate: field.groupdate

      // selectedSummarize: field.selectedSummarize,
      // summarize: this.selectedSummarize,
    };

    // Open the dialog with the initialized data
    this.dialogRef = this.dialog.open(this.groupRowsDialog, {
      data: this.data,
      height: "300px",
      width: "400px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
        // Update the name of the selected field in the grid data
        // this.selectedFieldNameMap[field.sectionName] = field;
      }
    });
  }

  savedialog(): void {
    // console.log("field", field);
    // if (!field) {
    //   return; // Do not open dialog if no field is selected
    // }

    // // Initialize data object with field name and checked value
    // this.data = {
    //   name: field.name,
    //   sort: field.sort,
    //   datatype: field.datatype,
    //   showuniquecount: field.showuniquecount ? true : false,
    //   fieldid: field.fieldid,
    //   sorttype: field.sorttype,
    //   groupdate: field.groupdate,

    //   // selectedSummarize: field.selectedSummarize,
    //   // summarize: this.selectedSummarize,
    // };

    // Open the dialog with the initialized data
    this.dialogRef = this.dialog.open(this.saveDialog, {
      data: this.data,
      height: "400px",
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result === "confirm") {
        // Update the name of the selected field in the grid data
        // this.selectedFieldNameMap[field.sectionName] = field;
        this.save();
      }
    });
  }
  confirm(): void {
    if (this.saveForm.controls["label"].value.toString().trim() == "") {
      this.showWarning("Label is mandatory");
      return;
    }
    if (this.saveForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Report name is mandatory");
      return;
    }
    if (this.saveForm.controls["folder"].value.toString().trim() == "") {
      this.showWarning("Select the Folder to Save");
      return;
    }
    this.dialogRef.close("confirm");
  }
  close(): void {
    this.dialogRef.close();
  }
  // ok(): void {
  //   this.dialogRef.close(this.data);
  //   console.log(this.data);
  //   this.columnsDone.forEach((column) => {
  //     if (column.fieldid === this.data.fieldid) {
  //       // Update the object with preferences from data
  //       column.sort = this.data.sort;
  //       column.showuniquecount = this.data.showuniquecount;
  //       // column.uniquecount = this.data.uniquecount;
  //     } else {
  //       // column.sort = "";
  //       // column.showuniquecount = false;
  //       if (typeof column.sort !== 'undefined') {
  //         column.sort = "";
  //       }
  //       if (typeof column.showuniquecount !== 'undefined') {
  //         column.showuniquecount = false;
  //       }
  //     }
  //   });
  //   // this.columnsDone.push(...this.data);
  //   // console.log(this.columnsDone);
  //   // if (this.selectedField) {
  //   //   // Update the properties of selectedField
  //   //   this.selectedField.sort = this.data.sort;
  //   //   this.selectedField.showuniquecount = this.data.uniquecount;
  //   //   // Close the dialog and emit the selectedField
  //   //   this.dialogRef.close(this.selectedField);
  //   // }
  // }
  ok(): void {
    this.dialogRef.close(this.data);
    console.log(this.data);
    this.columnsDone.forEach((column) => {
      if (column.fieldid === this.data.fieldid) {
        // Update the object with preferences from data if they are modified
        if (typeof this.data.sort !== "undefined") {
          column.sort = this.data.sort;
        }
        if (typeof this.data.showuniquecount !== "undefined") {
          column.showuniquecount = this.data.showuniquecount;
        }

        if (typeof this.data.selectedSummarize !== "undefined") {
          column.selectedSummarize = this.data.selectedSummarize;
        }

        if (typeof this.data.sortingcolumn !== "undefined") {
          column.sortingcolumn = this.data.sortingcolumn;
        }
        // Add other conditions for additional properties if needed
      }
      //  else {
      //   // Set default values for untouched fields
      //   if (
      //     typeof column.sort !== "undefined" &&
      //     typeof this.data.sort === "undefined"
      //   ) {
      //     column.sort = "";
      //   }
      //   if (
      //     typeof column.showuniquecount !== "undefined" &&
      //     typeof this.data.showuniquecount === "undefined"
      //   ) {
      //     column.showuniquecount = false;
      //   }
      // }
    });

    this.columnsDone.forEach((column) => {
      if (!column.hasOwnProperty("sort")) {
        column.sort = "ascending";
      }
      if (!column.hasOwnProperty("showuniquecount")) {
        column.showuniquecount = false; // Set default value for 'showuniquecount' property
      }

      if (!column.hasOwnProperty("selectedSummarize")) {
        column.selectedSummarize = []; // Set default value for 'showuniquecount' property
      }

      if (!column.hasOwnProperty("sortingcolumn")) {
        column.sortingcolumn = false; // Set default value for 'showuniquecount' property
      }
      // Add other conditions for additional properties if needed
    });

    this.groupRowsDone.forEach((grouprow) => {
      if (grouprow.fieldid === this.data.fieldid) {
        if (typeof this.data.sort !== "undefined") {
          grouprow.sort = this.data.sort;
        }
        if (typeof this.data.showuniquecount !== "undefined") {
          grouprow.showuniquecount = this.data.showuniquecount;
        }

        if (typeof this.data.groupdate !== "undefined") {
          grouprow.groupdate = this.data.groupdate;
        }
        if (typeof this.data.sorttype !== "undefined") {
          grouprow.sorttype = this.data.sorttype;
        }
      }
    });

    this.groupRowsDone.forEach((grouprow) => {
      if (!grouprow.hasOwnProperty("sort")) {
        grouprow.sort = "ascending";
      }
      if (!grouprow.hasOwnProperty("showuniquecount")) {
        grouprow.showuniquecount = false;
      }

      if (!grouprow.hasOwnProperty("groupdate")) {
        grouprow.groupdate = "Day";
      }
      if (!grouprow.hasOwnProperty("sorttype")) {
        grouprow.sorttype = "Column";
      }
      // Add other conditions for additional properties if needed
    });

    this.groupColumnsDone.forEach((groupcolumn) => {
      if (groupcolumn.fieldid === this.data.fieldid) {
        if (typeof this.data.sort !== "undefined") {
          groupcolumn.sort = this.data.sort;
        }
        if (typeof this.data.showuniquecount !== "undefined") {
          groupcolumn.showuniquecount = this.data.showuniquecount;
        }

        if (typeof this.data.groupdate !== "undefined") {
          groupcolumn.groupdate = this.data.groupdate;
        }
        if (typeof this.data.sorttype !== "undefined") {
          groupcolumn.sorttype = this.data.sorttype;
        }
      }
    });

    this.groupColumnsDone.forEach((groupcolumn) => {
      if (!groupcolumn.hasOwnProperty("sort")) {
        groupcolumn.sort = "ascending";
      }
      if (!groupcolumn.hasOwnProperty("showuniquecount")) {
        groupcolumn.showuniquecount = false;
      }

      if (!groupcolumn.hasOwnProperty("groupdate")) {
        groupcolumn.groupdate = "Day";
      }
      if (!groupcolumn.hasOwnProperty("sorttype")) {
        groupcolumn.sorttype = "Column";
      }
      // Add other conditions for additional properties if needed
    });
  }

  getReportTypeSectionById() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          reporttypesection: {
            reporttypeid: this.reportTypeId
          }
        }
      };
      console.log(this.reportTypeId);
      this.isLoading = true;
      this.dataService.getReportTypeSectionById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.reporttypesection = res.data.reporttypesection;
            // const report = res.data.reporttype;

            // this.detailForm.controls["name"].setValue(this.reporttype.)

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("no data");
            this.isLoading = false;
            resolve(null);

            //this.resetDetailFormControls();
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);

          //this.resetDetailFormControls();
        }
      );
    });
  }

  getReportTypeColumnById() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          reporttypecolumn: {
            reporttypeid: this.reportTypeId
          }
        }
      };
      this.isLoading = true;
      console.log(postOption);
      this.dataService.getReportTypeColumnById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log("Column", res);
          if (res.success == 1) {
            // this.reporttypecolumn = res.data.reporttypecolumn;
            var cols = res.data.reporttypecolumn;

            cols.sort(function (a: any, b: any) {
              var x = (a.displaynameoverride || "").toLowerCase();
              var y = (b.displaynameoverride || "").toLowerCase();

              if (x > y) {
                return 1;
              }
              if (x < y) {
                return -1;
              }
              return 0;
            });

            this.reporttypecolumn = cols.slice();
            // const report = res.data.reporttype;

            this.fieldList = []; // reset

            this.reporttypecolumn.sort((a: any, b: any) => {
              const labelA = (
                a.objectname +
                ": " +
                (a.displaynameoverride || "")
              ).toLowerCase();
              const labelB = (
                b.objectname +
                ": " +
                (b.displaynameoverride || "")
              ).toLowerCase();

              if (labelA > labelB) return 1;
              if (labelA < labelB) return -1;
              return 0;
            });

            // 2️⃣ Then build dropdown list
            this.reporttypecolumn.forEach((col: any) => {
              let strLabel = col.displaynameoverride || "";
              strLabel = strLabel.charAt(0).toUpperCase() + strLabel.slice(1);

              let formattedLabel = col.objectname + ": " + strLabel;

              this.fieldList.push({
                value: col.fieldid,
                label: formattedLabel,
                fieldtype: col.datatype,
                id: col.fieldname,
                metaobjectname: col.objectname
              });
            });

            // trigger change detection
            this.fieldList = [...this.fieldList];

            // this.detailForm.controls["name"].setValue(this.reporttype.)

            this.isLoading = false;
            this.isDataLoaded = true;
            resolve(null);
          } else {
            console.log("no data");
            this.isLoading = false;
            //this.resetDetailFormControls();
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);

          //this.resetDetailFormControls();
        }
      );
    });
  }

  getReportType() {
    // alert(id)
    return new Promise((resolve, reject) => {
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );

      this.isLoading = true;
      this.dataService
        .getReportTypes(organizationid, domain, subdomain)
        .subscribe(
          (res) => {
            console.log(res);
            if (res !== null && res.success == 1) {
              var reporttypes = res.data.reporttype;
              var repArr = [];
              //just add an empty entry sice this field is optional
              repArr.push({ value: "", label: "--None--" });
              for (let i = 0; i < reporttypes.length; i++) {
                // repArr.push({
                //   value: reporttypes[i].id,
                //   label: reporttypes[i].name
                // });
                repArr.push({
                  value: reporttypes[i].id,
                  label: reporttypes[i].name,
                  metaobjectid: reporttypes[i].metaobjectid,
                  metaobjectname: reporttypes[i].metaobjectname
                });
              }
              this.reportType = repArr;

              this.isLoading = false;
              resolve(null);
            } else {
              console.log("No Report Type data!");
              this.errorMessage =
                res != null ? res.message : "No Report Type data!";
              this.isError = true;
              this.isLoading = false;
              resolve(null);
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  getFolder() {
    return new Promise((resolve, reject) => {
      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );

      this.isLoading = true;
      this.dataService.getFolders(organizationid, domain, subdomain).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allFolders = res.data.folder;
            var foldArr = [];
            //just add an empty entry sice this field is optional
            foldArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allFolders.length; i++) {
              foldArr.push({
                value: allFolders[i].id,
                label: allFolders[i].name
              });
            }

            this.folders = foldArr;

            this.isLoading = false;

            resolve(null);
          } else {
            console.log("No Folder data!");
            this.errorMessage = res != null ? res.message : "No Folder data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getReportById() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          report: {
            id: this.reportId
          }
        }
      };
      console.log(this.reportId);
      this.isLoading = true;
      this.dataService.getReportById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // this.reporttype = res.data.reporttype;
            this.report = res.data.report;

            // ✅ SET FILTER LOGIC
            // this.filterForm.controls["filterlogic"].setValue(
            //   this.report.filterlogic || ""
            // );

            // // ✅ CLEAR DEFAULT FILTER ITEM
            // const filterArray = this.filterForm.get("filteritems") as FormArray;
            // filterArray.clear();
            // this.picklistValueList = [];

            // if (
            //   this.report.reportfilter &&
            //   this.report.reportfilter.length > 0
            // ) {
            //   this.report.reportfilter.forEach((f: any) => {
            //     // 🔥 find correct dropdown option using fieldname
            //     const matchedField = this.fieldList.find(
            //       (fld: any) => fld.id === f.fieldname // match DB fieldname
            //     );

            //     filterArray.push(
            //       this.fb.group({
            //         fieldid: [f.fieldname], // actual DB name
            //         fieldname: [matchedField ? matchedField.value : ""], // dropdown value
            //         fieldtype: [matchedField ? matchedField.fieldtype : ""],
            //         fieldoperator: [f.operator],
            //         fieldvalue: [f.value],
            //         metaobjectname: [
            //           matchedField ? matchedField.metaobjectname : ""
            //         ],
            //         options: [""]
            //       })
            //     );

            //     this.picklistValueList.push([]);
            //   });
            // } else {
            //   filterArray.push(this.createFilterItem());
            // }

            // var rep = res.data.report;
            // this.report = rep

            // console.log("Doneeee****", this.reporttype.name);
            // if (report != null) {
            //   // this.metaLayoutId = this.metaglobalaction.metalayoutid;
            //   // this.metaactionId = this.metaglobalaction.id;
            //   // this.metaactionName = this.metaglobalaction.name;
            //   // this.detailForm.controls["primaryobject"].setValue(
            //   //   this.reporttype.primaryobjectname
            //   // );
            //   this.detailForm.controls["label"].setValue(report.labelname);
            //   this.detailForm.controls["primaryobject"].setValue(
            //     report.primaryobjectname
            //   );
            //   this.detailForm.controls["name"].setValue(report.name);
            //   this.detailForm.controls["description"].setValue(
            //     report.description
            //   );

            //   this.retrievedObjectName = report.primaryobjectname;
            //   this.detailForm.controls["category"].setValue(report.category);

            //   // this.detailForm.controls["deploymentStatus"].setValue(
            //   //   this.reporttype.deployed
            //   // );

            //   if (report.deployed === false) {
            //     this.detailForm.controls["deploymentStatus"].setValue("false");
            //   } else {
            //     this.detailForm.controls["deploymentStatus"].setValue("true");
            //   }

            //   // this.detailForm.controls["parentobjectid"].setValue(
            //   //   "po9D000000k85TE"
            //   // );
            // }

            // this.detailForm.controls["name"].setValue(this.reporttype.)

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("no data");
            this.isLoading = false;
            resolve(null);

            //this.resetDetailFormControls();
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);

          //this.resetDetailFormControls();
        }
      );
    });
  }
  cancel() {
    this.router.navigateByUrl("/home/reports");
  }

  createReportFilter() {
    const arrReportFilter = [];

    const arrayControl = this.filterForm.get("filteritems") as FormArray;
    const isLocked = this.filterForm.get("locked").value;

    for (let c of arrayControl.controls) {
      const fieldId = c.get("fieldname").value; // this is dropdown value (fieldid)
      const fieldName = c.get("fieldid").value;
      const fieldType = c.get("fieldtype").value;
      const operator = c.get("fieldoperator").value;
      let value = c.get("fieldvalue").value;

      if (value === "--none--") value = "";

      if (fieldName && operator) {
        arrReportFilter.push({
          id: this.guid.getGUID("reportfilter"),
          reportid: this.reportId,
          fieldname: fieldName,
          fieldtype: fieldType,
          operator: operator,
          value: value,
          locked: isLocked,
          filterlogic: this.filterForm.controls["filterlogic"].value
        });
      }
    }

    // ✅ ADD LOCKED FILTER ALWAYS

    return arrReportFilter;
  }
  save() {
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));
    if (this.mode.toLowerCase() == "new") {
      this.reportId = this.guid.getGUID("report");
    }
    console.log(this.groupRowsDone);
    console.log(this.groupColumnsDone);

    var sortcolumnName = "";
    var sortobjectName = "";
    console.log(this.columnsDone);
    this.columnsDone.forEach((column) => {
      if (column.sortingcolumn == true) {
        sortcolumnName = column.fieldname;
        sortobjectName = column.section;
        this.formGroup.controls["sortcolumnname"].setValue(sortcolumnName);
        this.formGroup.controls["sortobjectname"].setValue(sortobjectName);
      }
    });

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profileid: userDetail.profileid,
      profilename: userDetail.profilename,
      data: {
        report: {
          id: this.reportId,
          reporttypeid: this.reportTypeId,
          description: this.saveForm.controls["description"].value,
          reportname: this.saveForm.controls["name"].value,
          reportlabel: this.saveForm.controls["label"].value,
          folderid: this.saveForm.controls["folderid"].value,
          foldername: this.saveForm.controls["foldername"].value,
          reportformat: this.formGroup.controls["reportformat"].value,
          rowlimit: this.formGroup.controls["rowlimit"].value,
          targeturl: this.formGroup.controls["targeturl"].value,
          scope: this.formGroup.controls["scope"].value,
          showdetailrows: this.formGroup.controls["detailrows"].value,
          showgrandtotals: this.formGroup.controls["grandtotals"].value,
          showsubtotals: this.formGroup.controls["subtotals"].value,
          sortcolumnname: this.formGroup.controls["sortcolumnname"].value,
          sortobjectname: this.formGroup.controls["sortobjectname"].value,
          sortorder: this.formGroup.controls["sortorder"].value,
          showstackedsummaries:
            this.formGroup.controls["stackedsummaries"].value,
          showrowcounts: this.formGroup.controls["rowcounts"].value,
          currency: "",
          filterlogic: "",
          mode: this.mode,
          reportcolumn: [],
          reportgroupingrow: [],
          reportgroupingcolumn: [],
          reportjsontext: [],
          reportfilter: []
        }
      }
    };

    this.columnsDone.forEach((column, index: any) => {
      this.reportcolumnId = this.guid.getGUID("reportcolumn");

      var reportColumn = {
        id: this.reportcolumnId,
        reportid: this.reportId,
        objectname: column.section,
        fieldname: column.fieldname,
        fieldid: column.fieldid,
        fieldlabel: column.labelname,
        datatype: column.datatype,
        sortorder: column.sort || "",
        showuniquecount: column.showuniquecount || false,
        aggregatetype: column.selectedSummarize || "",
        sortingcolumn: column.sortingcolumn || false,
        sequence: index
      };
      // index++;

      postOption.data.report.reportcolumn.push(reportColumn);
    });

    this.groupRowsDone.forEach((grouprow, index: any) => {
      this.reportGroupingRowId = this.guid.getGUID("reportgroupingrow");
      var reportGroupingRow = {
        id: this.reportGroupingRowId,
        reportid: this.reportId,
        objectname: grouprow.section,
        fieldname: grouprow.fieldname,
        groupinglabel: grouprow.labelname,
        fieldid: grouprow.fieldid,
        datatype: grouprow.datatype,
        dategranularity: grouprow.groupdate,
        // showuniquecount: grouprow.showuniquecount,
        sortorder: grouprow.sort,
        sorttype: grouprow.sorttype,
        sequence: index
      };
      postOption.data.report.reportgroupingrow.push(reportGroupingRow);
    });

    this.groupColumnsDone.forEach((groupcolumn, index: any) => {
      this.reportGroupingcolumnId = this.guid.getGUID("reportgroupingcolumn");
      var reportGroupingColumn = {
        id: this.reportGroupingcolumnId,
        reportid: this.reportId,
        objectname: groupcolumn.section,
        fieldname: groupcolumn.fieldname,
        groupinglabel: groupcolumn.labelname,
        fieldid: groupcolumn.fieldid,
        datatype: groupcolumn.datatype,
        dategranularity: groupcolumn.groupdate,
        // showuniquecount: groupcolumn.showuniquecount,
        sortorder: groupcolumn.sort,
        sorttype: groupcolumn.sorttype,
        sequence: index
      };
      postOption.data.report.reportgroupingcolumn.push(reportGroupingColumn);
    });

    //metaprofilelayoutweb
    // if (this.mode.toLowerCase() == "new") {
    this.reportJsontextId = this.guid.getGUID("reportjsontext");
    // }
    var reportjsontext = {
      id: this.reportJsontextId,
      reportid: this.reportId,
      reportname: this.saveForm.controls["name"].value,
      jsontext: {}
    };

    //push metaprofilelayout to request data (postoption)
    postOption.data.report.reportjsontext.push(reportjsontext);
    postOption.data.report.reportfilter = this.createReportFilter();

    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertReport(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("/home/reports");
        } else {
          console.log("Error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
